type UserAvatarProps = {
  url?: string | null;
  initial: string;
  className?: string;
  alt?: string;
};

/** Circular avatar: photo when available, otherwise initials. */
export function UserAvatar({
  url,
  initial,
  className = 'h-9 w-9 text-sm',
  alt = '',
}: UserAvatarProps) {
  if (url) {
    return (
      <img
        src={url}
        alt={alt}
        className={`shrink-0 rounded-full object-cover border-2 border-white shadow-[0_0_0_1px_var(--dash-line)] ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#3b66b8] to-[#8156b4] font-extrabold text-white ${className}`}
      aria-hidden={alt ? undefined : true}
    >
      {initial}
    </div>
  );
}
